var moduleMap = {
	"./AppRoutes": () => {
		return Promise.all([__webpack_require__.e(3156), __webpack_require__.e(561), __webpack_require__.e(402), __webpack_require__.e(8041), __webpack_require__.e(2035), __webpack_require__.e(8097), __webpack_require__.e(4914), __webpack_require__.e(2833), __webpack_require__.e(7319), __webpack_require__.e(9683), __webpack_require__.e(7221), __webpack_require__.e(3704), __webpack_require__.e(9625)]).then(() => (() => ((__webpack_require__(39625)))));
	},
	"./Shell": () => {
		return Promise.all([__webpack_require__.e(3156), __webpack_require__.e(561), __webpack_require__.e(402), __webpack_require__.e(8041), __webpack_require__.e(2035), __webpack_require__.e(8097), __webpack_require__.e(4914), __webpack_require__.e(2833), __webpack_require__.e(7319), __webpack_require__.e(9683), __webpack_require__.e(7221), __webpack_require__.e(3704), __webpack_require__.e(4712), __webpack_require__.e(1718)]).then(() => (() => ((__webpack_require__(41718)))));
	},
	"./ApiDocs": () => {
		return Promise.all([__webpack_require__.e(3156), __webpack_require__.e(561), __webpack_require__.e(3734), __webpack_require__.e(4914), __webpack_require__.e(2833), __webpack_require__.e(9683), __webpack_require__.e(2232)]).then(() => (() => ((__webpack_require__(22232)))));
	},
	"./ApplicationFrame": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(9683), __webpack_require__.e(7221), __webpack_require__.e(3250)]).then(() => (() => ((__webpack_require__(83250)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});